import { empApi } from "./client";

// =============================================================
// API Đào tạo (FEv1 - cổng nhân viên).
// Khớp 1-1 với các endpoint /training/app/* của app mobile (backend-v1).
// employeeCode được BE lấy từ token (req.user), FE không cần truyền.
// empApi.get đã bóc { status, message, data } -> trả thẳng phần data.
// =============================================================

// Danh sách chủ đề đào tạo -> { items, pagination }
export const getTrainingTopicsApi = (params) =>
  empApi.get("/training/app/topic", params);

// Danh sách bài giảng của một chủ đề -> { items, pagination }
export const getTrainingLecturesApi = (topicId, params) =>
  empApi.get(`/training/app/topic/${topicId}/lecture`, params);

// Danh sách bài học của một bài giảng -> { items, lectureTitle }
export const getTrainingLessonsApi = (lectureId) =>
  empApi.get(`/training/app/lecture/${lectureId}/lesson`);

// Thống kê lượt xem theo từng bài học -> { items: [{ lessonId, viewCount, viewerCount }] }
export const getTrainingLessonViewCountsApi = (lectureId) =>
  empApi.get(`/training/app/lecture/${lectureId}/lesson/view-count`);

// Thông tin chung của bài học (API này cũng ghi 1 lượt xem ở BE)
export const getTrainingLessonDetailApi = (lessonId) =>
  empApi.get(`/training/app/lesson/${lessonId}`);

// Tài liệu (tệp đính kèm) của bài học -> TrainingDocument[]
export const getTrainingLessonDocumentsApi = (lessonId, params) =>
  empApi.get(`/training/app/lesson/${lessonId}/document`, params);

// Link xem/tải một tệp đính kèm -> { url }
export const getTrainingDocumentViewLinkApi = (lessonId, attachmentId) =>
  empApi.get(
    `/training/app/lesson/${lessonId}/document/${attachmentId}/view-link`
  );

// Bộ câu hỏi trắc nghiệm của bài học -> { lessonId, title, questions }
export const getTrainingQuizApi = (lessonId) =>
  empApi.get(`/training/app/lesson/${lessonId}/quiz`);

// Lịch sử nộp bài của bản thân -> QuizSubmission[]
export const getTrainingQuizHistoryApi = (lessonId) =>
  empApi.get(`/training/app/lesson/${lessonId}/quiz/history`);

// Nộp bài trắc nghiệm -> QuizSubmission
export const submitTrainingQuizApi = (lessonId, answers) =>
  empApi.post(`/training/app/lesson/${lessonId}/quiz/submit`, { answers });
